<div class="open-sans">
  <button [matMenuTriggerFor]="menu" mat-icon-button class="icon">
    <mat-icon>menu</mat-icon>
  </button>
  <mat-menu #menu="matMenu" class="open-sans">
    @if (headerMenuElements) {
      @if (user) {
        <button mat-menu-item (click)="emitNavigationEvent('user')">
          <mat-icon>account_circle</mat-icon>
          {{ user.displayName }}
        </button>
      }
      @for (
        menuItem of headerMenuElements.nameUrls | keyvalue;
        track menuItem
      ) {
        @if (!menuItem.value.length) {
          <button
            mat-menu-item
            [matMenuTriggerFor]="items"
            (click)="emitNavigationEvent(menuItem.value)"
          >
            @if (headerMenuElements.matIcons[menuItem.key]) {
              <mat-icon>{{
                headerMenuElements.matIcons[menuItem.key]
              }}</mat-icon>
            }
            {{ menuItem.key }}
          </button>
        } @else {
          <button mat-menu-item (click)="emitNavigationEvent(menuItem.value)">
            @if (headerMenuElements.matIcons[menuItem.key]) {
              <mat-icon>{{
                headerMenuElements.matIcons[menuItem.key]
              }}</mat-icon>
            }
            {{ menuItem.key }}
          </button>
        }
        <mat-menu #items="matMenu">
          @for (item of menuItem.value | keyvalue; track item) {
            <button mat-menu-item>
              @if (headerMenuElements.matIcons[item.key]) {
                <mat-icon>{{ headerMenuElements.matIcons[item.key] }}</mat-icon>
              }
              {{ item.key }}
            </button>
          }
        </mat-menu>
      }
    }
  </mat-menu>
</div>
